var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Channel } from "core/codegen/types";
import { Dropdown } from "core/components/Dropdown";
import { useWindowWidth } from "core/customHooks/useWindowWidth";
import { activeItemVar } from "core/state";
import { mq } from "core/styles/snippets";
import { Id } from "core/utils";
import { ChannelChip } from "pages/programs/components/ChannelChip";
import React from "react";
import styled from "styled-components";
export var ChannelField = function (_a) {
    var userInput = _a.userInput, setUserInput = _a.setUserInput, darkMode = _a.darkMode, onMouseEnter = _a.onMouseEnter;
    var windowWidth = useWindowWidth();
    return (React.createElement(StyledField, { onChange: function (value) {
            setUserInput(__assign(__assign({}, userInput), { channel: {
                    current: convertStringToChannel(value),
                    previous: userInput.channel.current,
                } }));
            activeItemVar(undefined);
        }, darkMode: darkMode, value: userInput.channel.current, width: windowWidth, onMouseEnter: onMouseEnter, options: [
            { value: "all", label: "Alle zenders" },
            { value: Channel.Vtm, label: "VTM" },
            { value: Channel.Vtm2, label: "VTM 2" },
            { value: Channel.Vtm3, label: "VTM 3" },
            { value: Channel.Vtm4, label: "VTM 4" },
        ], componentId: Id.component.programsPage.search.channel }));
};
var convertStringToChannel = function (value) {
    return value;
};
export var Field = function (_a) {
    var onChange = _a.onChange, onMouseEnter = _a.onMouseEnter, value = _a.value, width = _a.width, options = _a.options, darkMode = _a.darkMode, componentId = _a.componentId, className = _a.className;
    if (width <= 0) {
        return React.createElement(Container, { className: className }); // Return empty container with same height
    }
    if (width < 768) {
        return (React.createElement(Container, { className: className },
            React.createElement(StyledDropdown, { options: options, defaultValue: value, onChange: onChange, "data-component": componentId, identifier: "channel-filter" })));
    }
    return (React.createElement(Container, { className: className },
        React.createElement(Chips, { "data-component": componentId }, options.map(function (option) { return (React.createElement(ChannelChip, { onClick: onChange, key: option.value, channel: option.value, darkMode: darkMode, active: option.value === value })); }))));
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 4.5rem;\n"], ["\n  min-height: 4.5rem;\n"])));
var Chips = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: fit-content;\n  gap: 0.25rem;\n  padding: 0;\n"], ["\n  display: flex;\n  width: fit-content;\n  gap: 0.25rem;\n  padding: 0;\n"])));
var StyledDropdown = styled(Dropdown)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: max-content;\n"], ["\n  width: 100%;\n  height: max-content;\n"])));
var StyledField = styled(Field)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n\n  ", " {\n    width: auto;\n  }\n"], ["\n  width: 100%;\n\n  ", " {\n    width: auto;\n  }\n"])), mq.minWidth("48rem"));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
